import { i18n } from 'i18next'
import _ from 'lodash'
import { matchPath } from 'react-router'
import { Middleware } from 'redux'

interface RouteConfig {
  [key: string]: string // Allow string indexing for route paths
}

const trackLocationChange = (action: any, dataLayer: any, i18n: i18n) => {
  const pathname = action.payload.currentLocationPath
  const currentLanguage = i18n.language
  const routes: RouteConfig = i18n.store.data[currentLanguage].routes as RouteConfig
  const regex = new RegExp(`^(/${currentLanguage})`)
  const strippedPathname = _.replace(pathname, regex, '')
  const matchedRoute = _.find(_.keys(routes), key => {
    const routePath = routes[key]
    return matchPath({ path: routePath, caseSensitive: false, end: false }, strippedPathname)
  })

  if (matchedRoute) {
    dataLayer.push({ pageCategory: matchedRoute })
  }
}

export const getGtmMiddleware =
  ({ i18n }: { i18n: i18n }): Middleware =>
  () => {
    return next => action => {
      const dataLayer = (window as any).dataLayer || []
      switch (action.type) {
        case 'LOCATION_CHANGE':
          trackLocationChange(action, dataLayer, i18n)
      }
      next(action)
    }
  }
